import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, apiError } from "@/lib/api";

const STATUSES = [
  ["available", "Available"], ["booked", "Booked"],
  ["maintenance", "Under Maintenance"], ["unavailable", "Temporarily Unavailable"],
];

export default function StationsTab() {
  const [items, setItems] = useState(null);
  const [name, setName] = useState("");
  const [type, setType] = useState("ps5");

  const load = () => api.get("/admin/stations").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    try { await api.patch(`/admin/stations/${id}/status`, { status }); toast.success("Station updated"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const add = async () => {
    if (!name.trim()) return;
    try { await api.post("/admin/stations", { name, type, status: "available", order: (items?.length || 0) + 1 }); setName(""); toast.success("Station added"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const del = async (id) => {
    try { await api.delete(`/admin/stations/${id}`); toast.success("Station removed"); load(); }
    catch (e) { toast.error(apiError(e)); }
  };

  if (!items) return <Loader2 className="animate-spin text-purple-400" />;
  return (
    <div>
      <div className="glass rounded-2xl p-4 mb-5 flex flex-wrap gap-3 items-end">
        <div className="flex-1 min-w-[160px]">
          <label className="text-xs text-purple-400 font-mono uppercase">New Station Name</label>
          <Input data-testid="new-station-name" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. PS5 Station 4" className="mt-1 h-11 bg-purple-950/30 border-purple-500/30" />
        </div>
        <select value={type} onChange={(e) => setType(e.target.value)} data-testid="new-station-type" className="h-11 rounded-xl bg-purple-950/40 border border-purple-500/30 px-3 text-sm">
          <option value="ps5">PS5</option><option value="pc">PC</option>
        </select>
        <Button data-testid="add-station-btn" onClick={add} className="h-11 bg-purple-600 hover:bg-purple-500"><Plus size={16} /> Add</Button>
      </div>

      <div className="space-y-3">
        {items.map((st) => (
          <div key={st.id} className="glass rounded-2xl p-4 flex flex-wrap items-center justify-between gap-3" data-testid={`station-${st.id}`}>
            <div>
              <p className="font-semibold">{st.name}</p>
              <p className="text-xs text-slate-500 uppercase font-mono">{st.type}</p>
            </div>
            <div className="flex items-center gap-2">
              <select value={st.status} onChange={(e) => setStatus(st.id, e.target.value)} data-testid={`station-status-${st.id}`} className="h-10 rounded-xl bg-purple-950/40 border border-purple-500/30 px-3 text-sm">
                {STATUSES.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
              </select>
              <Button size="icon" variant="outline" onClick={() => del(st.id)} className="h-10 w-10 border-red-500/30 bg-transparent text-red-300"><Trash2 size={15} /></Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
